<template>
    <div class="bottom"></div>
</template>

<script>
export default {
    name: 'headtitle.temhead8'
}
</script>

<style lang="scss" scoped>
.bottom {
    width: 100%;
    height: 32.5px;
    margin-top: auto;
    background: url(@/assets/temimg16/bottom.png) no-repeat;
    background-size: 100% 100%;
    z-index: 400;
    position: absolute;
    bottom: 0;
}
</style>